import _cookies from "../../../shared/utils/_cookies";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

export const getSocialMediaFeed = async (params) => {
  const urlSearchParams = new URLSearchParams({
    ...params,
  }).toString();
  const res = await fetch(
    "https://middleware.cadernovirtual.com.br/Social.asmx/feedAluno?" +
      urlSearchParams,
    {
      headers: {
        "Content-Type": "application/json",
        token: _cookies.getItem("auth").token,
      },
    }
  );
  const data = await res.json();
  return data.d.result.map((foo) => ({ ...foo, currentPage: params.pagNum }));
};

export const useInfiniteUserPosts = ({
  config,
  studentId = 1,
  pageLength = 30,
  pageNumber = 1,
} = {}) => {
  const params = {
    alunoid: studentId,
    pagNum: pageNumber,
    pagLength: pageLength,
    temaid: -1,
  };
  return useInfiniteQuery({
    ...config,
    queryKey: ["socialMediaFeed", { studentId }],
    queryFn: ({ pageParam = 1 }) =>
      getSocialMediaFeed({ ...params, pagNum: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.[0]?.currentPage == lastPage?.[0]?.total_paginas) {
        return undefined;
      }
      return lastPage?.[0]?.currentPage + 1;
    },
  });
};
